import { ProgressBar, ProgressBarMode } from "../../Global/Progressbar";
import { InitData, TicketList } from "../../../Components/ProductList/TicketList";
import { SummaryRedirect } from "../../../Lib/Helper/AxProdSelection/SummaryRedirect";

export abstract class NonPreDateable {
    protected PostURL: string;

    constructor(protected _Progressbar = new ProgressBar(),
        protected _TicketList = new TicketList(),
        protected _summaryRedirect = new SummaryRedirect()) { }

    Init(initData: AxProdNonPredateableInit): void {
        this.PostURL = initData.PostURL;

        this._Progressbar.Init({
            Mode: ProgressBarMode.Default,
            Progress: 0
        });

        this._TicketList.Init(initData);
        this._TicketList.QuantityOkSubject.subscribe(x => this.CheckSubmit(x));
    }

    CheckSubmit(quantityOk: boolean): boolean {
        if (quantityOk) {
            $('.prod_selection__persontype-submit').removeAttr('disabled');
            $('.prod_selection__prod-save').removeAttr('disabled');
            $('.prod_selection__summary').toggle(true);
            return true;
        } else {
            $('.prod_selection__persontype-submit').attr('disabled', 'disabled');
            $('.prod_selection__prod-save').attr('disabled', 'disabled');
            $('.prod_selection__summary').toggle(false);
            return false;
        }
    }

    abstract ToSummary(): void;
}

export interface AxProdNonPredateableInit extends InitData {
    PostURL: string;
}